import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  RedefineAppointmentServiceInput,
  useRedefineAppointmentServiceMutation as redefineAppointmentServiceMutation,
  useRedefineAppointmentServiceMutation$data,
} from "@/modules/waiting-room/services/__generated__/useRedefineAppointmentServiceMutation.graphql"

const mutation = graphql`
  mutation useRedefineAppointmentServiceMutation($input: RedefineAppointmentServiceInput!) {
    redefineAppointmentService(input: $input) {
      appointment {
        appointmentId
        appointmentType
        assignedTo
        id
        service
        specialty
      }
      errors {
        ... on AppointmentNotFound {
          __typename
          message
        }
        ... on PatientFileIsLocked {
          __typename
          message
        }
        ... on FeatureIsDisabledDuringDayLightSavingTime {
          __typename
          message
        }
        ... on ServiceDoesNotAllowTheConsultationType {
          __typename
          message
        }
      }
    }
  }
`

export type RedefineAppointmentServiceError = NonNullable<
  useRedefineAppointmentServiceMutation$data["redefineAppointmentService"]["errors"]
>[number]["__typename"]

export function useRedefineAppointmentServiceMutation() {
  const [commit] = useMutation<redefineAppointmentServiceMutation>(mutation)

  return useCallback(
    (
      input: RedefineAppointmentServiceInput,
      handleCompleted?: ((response: useRedefineAppointmentServiceMutation$data) => void) | undefined,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted: handleCompleted,
      })
    },
    [commit],
  )
}
